import { apiConstants } from '../../apiConstant'
import { formDataCommonFunction, formDataCommonFunctionUnAuth } from '../../serviceCall'

export const getPurchaseList = (data, callback, errorCallBack) => {
    return async (dispatch) => {
        formDataCommonFunctionUnAuth(data, apiConstants.TICKET.GET_PURCHASE_LIST)
            .then((response) => {
                callback && callback(response)
            })
            .catch((error) => {
                errorCallBack && errorCallBack(error.response)
            })
    }
} 
